import React from "react";
import classNames from "classnames";
import bgCoastDawn from "../media/backgrounds/coast-dawn.jpg";
import bgCostalWaves from "../media/backgrounds/costal-waves.jpg";
import bgLake from "../media/backgrounds/lake.jpg";
import bgPeaks from "../media/backgrounds/peaks.jpg";
import bgTreesDay from "../media/backgrounds/trees-day.jpg";
import bgTreesDusk from "../media/backgrounds/trees-dusk.jpg";
import Pointer from "./Pointer";
import styles from "./Hero.module.css";

// Background images from unsplash.com.
const BACKGROUNDS: Readonly<string[]> = [
  bgCoastDawn,
  bgCostalWaves,
  bgLake,
  bgPeaks,
  bgTreesDay,
  bgTreesDusk,
];

interface HeroProps {
  services: React.RefObject<HTMLElement | null>;
}

const Hero: React.FC<HeroProps> = ({ services }) => {
  const [backgroundIndex] = React.useState(
    () => (Math.random() * BACKGROUNDS.length) | 0,
  );
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const image = BACKGROUNDS[backgroundIndex];

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const scrollToServices = () => {
    services.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className={styles.hero}>
      <div
        className={classNames(styles.image, {
          [styles.fadeIn]: imageLoaded,
        })}
        style={{ backgroundImage: `url(${image})` }}
      />

      <div className={styles.content}>
        <h1 className={styles.title}>Lyra Productions LLC</h1>
        <Pointer onClick={scrollToServices} />
      </div>

      <img
        src={image}
        onLoad={handleImageLoad}
        style={{ display: "none" }}
        alt=""
      />
    </section>
  );
};

Hero.displayName = "Hero";

export default Hero;
